// extracted by mini-css-extract-plugin
export default {"container":"AppList_container_Neh8Z"};